export default __webpack_public_path__ + "static/media/1306.33db04b0.jpg";